import './styles/InsertIssuesStyle.css';
import React, { useEffect, useState } from 'react';
import {
  NavigationButton,
  ToastType,
  TopNav,
  TopNavToastMessage,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { APIResponseStatusType, navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';
import {
  IncidentRequestGET,
  IncidentRequestPOST,
  IncidentResponseGET,
  IncidentResponsePOST,
} from '../../models/cruds';
import { apiErrorHandler, apiGET, apiPOST } from '../../restApi';
import { Incident } from '../../models/microservices';
import Spinner from 'react-bootstrap/Spinner';

const ISSUE_CODE_SCALE_UP = 'A';
const ISSUE_CODE_SCALE_DOWN = 'J';
const ISSUE_CODE_DOES_NOT_OPEN = 'B';
const ISSUE_CODE_DOES_NOT_CLOSE = 'C';
const ISSUE_CODE_INSERTED_WRONG_PIECE = 'G';
const ISSUE_CODE_LOCKER_CLOSED = 'H';
const ID_LOCKER_POSITION_TYPE_SMALL = 1;
const COMPLETE_ISSUE_LIST = [
  ISSUE_CODE_SCALE_UP,
  ISSUE_CODE_SCALE_DOWN,
  ISSUE_CODE_DOES_NOT_OPEN,
  ISSUE_CODE_DOES_NOT_CLOSE,
  ISSUE_CODE_INSERTED_WRONG_PIECE,
  ISSUE_CODE_LOCKER_CLOSED,
];
const REDUCED_ISSUE_LIST = [
  ISSUE_CODE_SCALE_UP,
  ISSUE_CODE_DOES_NOT_OPEN,
  ISSUE_CODE_DOES_NOT_CLOSE,
  ISSUE_CODE_INSERTED_WRONG_PIECE,
  ISSUE_CODE_LOCKER_CLOSED,
];
const SELECT_INCIDENT = 'Por favor selecciona una incidencia';
const VALIDATION_ERROR = 'Error en la consulta';

const InsertIssues: React.FC = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [selectedIncident, setSelectedIncident] = useState<Incident>(
    {} as Incident
  );
  const [incidentList, setIncidentList] = useState<Incident[]>([]);
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const token = useTypedSelector(({ session }) => {
    return session.dhlApiToken;
  });
  const agentToken = useTypedSelector(({ session }) => {
    return session.dhlAgentToken;
  });
  const currentLockerPosition = useTypedSelector(({ locker }) => {
    return locker.currentLockerPosition;
  });
  const currentPackageCandidate = useTypedSelector(({ locker }) => {
    return locker.currentPackageCandidate;
  });
  const { updateCurrentLockerPosition } = useActions();
  useEffect(() => {
    const getIncidents = async (): Promise<boolean> => {
      setLoading(true);
      let request = new IncidentRequestGET();
      let response: IncidentResponseGET = await apiGET(
        request.buildURL(),
        request.generateConfig(token)
      );
      let errorMsg = '';
      try {
        if (response.status === APIResponseStatusType.SUCCESS) {
          if (response.data.incidents) {
            let filteredList = response.data.incidents.filter((incident) =>
              COMPLETE_ISSUE_LIST.includes(incident.code)
            );
            if (
              currentLockerPosition.lockerPositionType?.id ===
              ID_LOCKER_POSITION_TYPE_SMALL
            ) {
              filteredList = response.data.incidents.filter((incident) =>
                REDUCED_ISSUE_LIST.includes(incident.code)
              );
            }
            setIncidentList(filteredList);
            setLoading(false);
            return true;
          } else {
            //TODO check for unauth and refresh token
            errorMsg = 'Unauthorized';
          }
        } else {
          errorMsg = apiErrorHandler(response);
        }
      } catch (err: any) {
        errorMsg = err.toString();
      }
      console.log(errorMsg);
      setFeedbackMessage(VALIDATION_ERROR);
      setLoading(false);
      return false;
    };
    getIncidents();
  }, [token, currentLockerPosition]);
  const postIssueAsync = async (): Promise<boolean> => {
    let packageCandidateId = currentPackageCandidate.id ?? 0;
    let lockerPositionId = currentLockerPosition.id;
    let request = new IncidentRequestPOST();
    let response: IncidentResponsePOST = await apiPOST(
      request.buildURL(),
      request.generateContent(
        packageCandidateId,
        lockerPositionId,
        selectedIncident.id
      ),
      request.generateConfig(agentToken)
    );
    let errorMsg = '';
    try {
      if (response.status === APIResponseStatusType.SUCCESS) {
        return true;
      } else {
        errorMsg = apiErrorHandler(response);
      }
    } catch (err: any) {
      errorMsg = err.toString();
    }
    console.log(errorMsg);
    setFeedbackMessage(VALIDATION_ERROR);
    setLoading(false);
    return false;
  };
  const handleClosedLocker = () => {
    updateCurrentLockerPosition({
      ...currentLockerPosition,
      retrieved: false,
    });
    history.replace(`/${navigationPages.INSERT_PIECE}`);
  };
  const confirmIssue = async () => {
    if (selectedIncident.code === '') {
      setFeedbackMessage(SELECT_INCIDENT);
      return;
    }
    switch (selectedIncident.code) {
      case ISSUE_CODE_SCALE_UP:
      case ISSUE_CODE_SCALE_DOWN:
      case ISSUE_CODE_DOES_NOT_OPEN:
      case ISSUE_CODE_DOES_NOT_CLOSE:
        if (await postIssueAsync()) {
          history.replace(`/${navigationPages.INSERT_SCAN_PID}`);
        }

        break;
      case ISSUE_CODE_INSERTED_WRONG_PIECE:
      case ISSUE_CODE_LOCKER_CLOSED:
        handleClosedLocker();
        return;
      default:
        break;
    }
  };
  const renderContent = () => {
    if (loading) {
      return (
        <div className="remove-issues-issue-list-container">
          <div className="spinner-container">
            <Spinner className="spinner" animation="grow" variant="danger" />
          </div>
        </div>
      );
    }
    return (
      <div className="remove-issues-issue-list-container">
        {incidentList.map((incident) => {
          return (
            <div
              key={incident.id}
              className={`remove-issues-issue-container ${
                incident.id === selectedIncident.id ? 'selected' : ''
              } `}
              onClick={() => setSelectedIncident(incident)}
            >
              <p className="remove-issues-issue-name">{incident.name}</p>
              <div
                className={`remove-issues-issue-indicator ${
                  incident.id === selectedIncident.id ? 'selected' : ''
                } `}
              />
            </div>
          );
        })}
      </div>
    );
  };
  const renderButton = () => {
    if (loading) {
      return null;
    }
    return (
      <NavigationButton
        buttonContent={languageMap.remove_issues.confirm_button[language]}
        buttonClass="navigation-button confirm-button"
        onClickButton={() => {
          confirmIssue();
        }}
      />
    );
  };
  return (
    <div id="insertIssues" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container">
            <p className="header nopadding nomargin">
              {languageMap.insert_issues.title[language]}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={languageMap.remove_issues.back_button[language]}
                buttonClass="navigation-button cancel-button"
                onClickButton={() => {
                  history.replace(`/${navigationPages.INSERT_PIECE}`);
                }}
              />
            </div>
            <div className="footer-button-container">{renderButton()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { InsertIssues };
